import React from 'react';
import { StatusCodes } from 'http-status-codes';

import Loading from '../../General/Loading';
import Table from '../Table/Table';

import useGetPropertiesPerLabel from '../../../Hook/ProductProperties/UseGetPropertiesPerLabel';
import useIsFilterLoading from '../../../Hook/Interest/UseIsFilterLoading';
import useGetFilteredValues from '../../../Hook/Interest/UseGetFilteredValues';
import useGetLastResponseCode from '../../../Hook/Interest/UseGetLastResponseCode';
import { Warning } from '../../General/Warning';
import { ExportPdf } from '../Pdf/ExportPdf';
import InterestUri from '../../../Enum/InterestUri';

const PropertiesPerLabelTable: React.FC = () => {
    const { labels } = useGetFilteredValues();
    const filterIsLoading = useIsFilterLoading();
    const { error, data, headers, loading } = useGetPropertiesPerLabel(labels);
    const lastResponseCode = useGetLastResponseCode();

    if (labels.length === 0) {
        return <p className="no-results">Selecteer één tot acht producten om te beginnen.</p>;
    }

    if (filterIsLoading || loading) {
        return <Loading />;
    }

    if (error || !data.length || !headers.length) {
        return <p className="no-results">Geen resultaten gevonden, pas uw filters aan.</p>;
    }

    return (
        <>
            {lastResponseCode === StatusCodes.PARTIAL_CONTENT && (
                <Warning content="Door technische problemen ziet u niet het volledige resultaat. Probeer het later nog eens." />
            )}
            <ExportPdf headers={headers} rows={data} section={InterestUri.PropertiesPerLabel} scopable />
            <Table
                className="properties-per-label"
                data={data}
                headers={headers}
                section={InterestUri.PropertiesPerLabel}
                scopable
            />
        </>
    );
};

export default PropertiesPerLabelTable;
